import styled from "styled-components/macro";

export const Container = styled.div`
  position: absolute;
  width: 400px;
  top: -80px;
  left: 50%;
  transform: translate(-50%, 0);
  overflow: hidden;
  border-radius: 25px;
  margin: 16px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--document-background);
  box-shadow: var(--card-drop-shadow);
  z-index: 100000000;
  cursor: default;

  .text-content {
    margin-bottom: 12px;
    text-align: center;
    color: var(--grey-1);
    margin-bottom: 20px;
    font-size: 15px;
    line-height: 19px;
  }

  video {
    width: 100%;
    margin-bottom: 15px;
  }

  button.try {
    border-radius: 10px !important;
    font-family: "Inter" !important;
    font-weight: 500 !important;
    letter-spacing: 0 !important;
  }
`;
